<template>
  <div class="d-contents">
    <v-skeleton-loader v-if="!tenderOffers" type="table-tbody" />
    <TenderPlug
      v-else-if="!offersLength"
      :title="$t('There are no offers yet')"
      :description="
        $t('As soon as the companies submit their prices, you can compare them in this tab')
      "
    >
      <template #icon><BurgerDots :style="{ height: '50px' }" /></template>
    </TenderPlug>
    <div v-else class="tender-offers-page flex-row">
      <div>
        <div
          class="tender-summary-offers-table incoming-tender-offers-table"
          :style="{
            'grid-template-columns': `220px repeat(${offersLength}, 180px)`,
          }"
        >
          <TenderOffersLegend :tender-offers="tenderOffers" />
          <div class="d-contents">
            <div
              v-for="(offer, columnIndex) in offersColumns"
              :key="offer.id"
              class="offers-column offers-table-column_values"
            >
              <TenderOffersColumn
                :offer="offer"
                :tender-offers="tenderOffers"
                :column-index="columnIndex"
                :rows-count="rowsCount"
                :selected-version="selectedVersions[offer.id]"
                @change-version="(version) => handleVersionChanging(version, offer.id)"
              />
            </div>
          </div>
        </div>
        <div v-if="selectedVersions" class="tender-offers-page__total">
          <span
            class="offers-table-cell__total offers-table-cell__total_main text-sm offers-table-cell_sticky grey-900"
          >
            {{ $t('Total price') }}
          </span>
          <div v-for="({ id, versions }, idx) in offersColumns" :key="idx">
            <div
              v-if="versions.length"
              class="text-sm offers-table-cell__total offers-table-cell__total-cell offers-table-cell__total-title spacex-4"
              :class="{
                'offers-table-cell_disabled':
                  selectedVersions[id].status === 'old' ||
                  selectedVersions[id].status === 'disabled',
              }"
            >
              <span class="table-cell-currency">
                {{ currencySymbols[tenderInfo.currency] }}
              </span>
              <span class="grey-900">
                {{ addSpaces(selectedVersions[id].final_budget) }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="tender-offers-page__import-offer">
        <Button max type="func" left-icon="plus" @click="importOffer">{{
          $t('Import offer')
        }}</Button>
      </div>
    </div>
  </div>
</template>

<script>
  import TenderOffersColumn from '@/containers/tender/tender-offers-table/TenderOffersColumn';
  import TenderOffersLegend from '@/containers/tender/tender-offers-table/TenderOffersLegend';
  import { mapActions, mapMutations, mapState } from 'vuex';
  import addSpaces from '@/utils/formatting/add-spaces';
  import TenderPlug from '@/components/tender/TenderPlug';
  import BurgerDots from '@/assets/icons/burger-dots.svg';
  import get from 'lodash.get';
  import { VSkeletonLoader } from 'vuetify/lib';
  import Button from '@/components/ui-v2/Button';
  import CreateOfferModal from '@/components/tender/CreateOfferModal';

  export default {
    name: 'TenderOffersPage',
    components: {
      TenderPlug,
      TenderOffersColumn,
      TenderOffersLegend,
      BurgerDots,
      VSkeletonLoader,
      Button,
    },
    computed: {
      ...mapState('global', ['currencySymbols']),
      ...mapState('tender', [
        'tenderOffers',
        'tenderOffersLoading',
        'showOldAndArchivedOffers',
        'selectedVersions',
        'tenderInfo',
      ]),
      // TODO: обсудить изменение апишки, чтобы не слать офферы без версий
      offersLength() {
        return this.offersColumns.filter((offer) => offer.versions.length).length;
      },
      offersColumns() {
        return this.showOldAndArchivedOffers
          ? this.tenderInfo?.offers
          : this.tenderInfo?.offers.map((offer) => {
              return {
                ...offer,
                versions: offer.versions.filter((version) => version.status !== 'archived'),
              };
            });
      },
      rowsCount() {
        return this.tenderOffers?.lists?.length;
      },
    },
    methods: {
      get,
      ...mapActions('publicTender', ['initPublicTenderInfo']),
      ...mapActions('modal', ['openModal']),
      ...mapMutations('tender', ['changeSelectedVersion']),
      addSpaces,
      handleVersionChanging(version, offerId) {
        this.changeSelectedVersion({
          version,
          offerId,
        });
      },
      async importOffer() {
        await this.initPublicTenderInfo({
          tenderHash: this.tenderInfo.public_link_hash,
          isPublic: false,
        });
        this.openModal({
          component: CreateOfferModal,
        });
      },
    },
  };
</script>
